import { Group, GroupAddress } from '@/types/api/group';
import { CreateGroupRequest, UpdateGroupAddressRequest } from '@/types/api/group/request';
import { CreateGroupResponse } from '@/types/api/group/response/create-group.response';
import { GetGroupNameResponse } from '@/types/api/group/response/get-group-name.response';
import { authenticatedClient, unauthenticatedClient } from '@/utils/shared/axios';
import { handleApiError } from '@/utils/shared/handle-api-error';

export default {
  create: async (data: CreateGroupRequest) => {
    try {
      const response = await authenticatedClient.post<CreateGroupResponse>(`/groups/register`, data);
      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  },

  get: async (id: string, params: object = {}) => {
    const response = await authenticatedClient.get(`/groups/${id}`, { params });
    return response.data;
  },

  getNames: async (params: object = {}) => {
    const response = await authenticatedClient.get(`/groups/name`, { params });
    return response.data;
  },

  getName: async (id: string) => {
    const response = await unauthenticatedClient.get<GetGroupNameResponse>(`/groups/${id}/name`);
    return response.data;
  },

  list: async (ids: string[]) => {
    const response = await authenticatedClient.get<Group[]>(`/groups/batch`, {
      params: {
        id: ids.join(','),
      },
    });

    return response.data;
  },

  current: async (params: object = {}) => {
    const response = await authenticatedClient.get(`/groups/current`, { params });
    return response.data;
  },

  update: async (data: {}) => {
    const response = await authenticatedClient.patch(`/groups/current`, data);
    return response.data;
  },

  address: {
    get: async () => {
      const response = await authenticatedClient.get<GroupAddress>(`/groups/current/address`);
      return response.data;
    },

    update: async (data: UpdateGroupAddressRequest) => {
      const response = await authenticatedClient.put<void>(`/groups/current/address`, data);
      return response.data;
    },
  },
};
